import * as _ from 'lodash';
import { Setting } from './setting.model';
import { SettingInterface } from './setting.interface';

export class SettingFactory {

    static empty(): Setting {
        // tslint:disable-next-line:max-line-length
        return new Setting('', '', '','', '', '', '', '', '', '', '', 0, false, '', '', '', '', '', '', 'en', '', '', '', '', true, true, true, {}, '', false, false, false, [], new Date(0), new Date(0), false, false, '', false);
    }

    static fromObject(raw: SettingInterface | any): Setting {
        if (raw.success === false) {
            throw new Error(raw.message);
        }
        return new Setting(
            raw.id,
            raw.name,
            raw.appName,
            raw.icon,
            raw.banner,
            raw.email,
            raw.emailSenderName,
            raw.emailSender,
            raw.emailSupport,
            raw.baseURL,
            raw.privacyPolicy,
            raw.backupFrequency,
            raw.isBackupActive,
            raw.androidId,
            raw.androidURL,
            raw.androidVersion,
            raw.appStoreId,
            raw.appStoreURL,
            raw.appStoreVersion,
            raw.contentLanguage,
            raw.letterTitle,
            raw.letterMessage,
            raw.letterFooter,
            raw.classbookNotificationType,
            raw.classbookReplyAllowed,
            raw.optionMessageCategories,
            raw.translationStatus,
            raw.translationDisableLanguages,
            raw.copyrightTextImages,
            raw.imageDownloadAllowed,
            raw.classBookDisabled,
            raw.notifyUsersWithSameSecret,
            raw.userFields,
            raw.messageStartDate && raw.messageStartDate._seconds ? new Date(raw.messageStartDate._seconds * 1000) : raw.messageStartDate,
            raw.classbookStartDate && raw.classbookStartDate._seconds ? new Date(raw.classbookStartDate._seconds * 1000) : raw.classbookStartDate,
            raw.isImportantAdmin,
            raw.isImportantTeacher,
            raw.dataConfirmationFieldId || '',
            raw.richTextMessages === true,
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/settings/shared/setting.factory.ts